import React from "react";
import { useTranslation } from "react-i18next";
import VisitorCounter from "../components/VisitorCounter";

function Footer() {
  const { i18n } = useTranslation();

  const year = new Date().getFullYear();

  // Convert English digits → Marathi digits (no commas)
  // const toMarathiDigits = (num) =>
  //   num.toString().replace();

   // Convert English digits → Marathi digits
  const toMarathiDigits = (num) => {
    const marathiDigits = ["०","१","२","३","४","५","६","७","८","९"];
    return num
      .toString()
      .split("")
      .map(d => marathiDigits[d])
      .join("");
  };


  const displayYear =
    i18n.language === "mr" ? toMarathiDigits(year) : year;

  return (
    <footer
      className="border-t"
      style={{
        background: "linear-gradient(to right, #b8860b, #daa520, #b8860b)",
      }}
    >
      <div className="flex flex-col items-center gap-1.5 px-2 py-2 mx-auto text-xs text-white max-w-7xl">
        <VisitorCounter />

        {/* Bhashini Attribution Badge */}
        <a
          href="https://bhashini.gov.in"
          target="_blank"
          rel="noopener noreferrer"
          title="Bhashini - National Language Translation Mission, Ministry of Electronics & IT, Govt. of India"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '4px 14px',
            borderRadius: '999px',
            background: 'rgba(0, 0, 0, 0.22)',
            backdropFilter: 'blur(6px)',
            border: '1px solid rgba(255, 255, 255, 0.40)',
            color: '#ffffff',
            textDecoration: 'none',
            fontSize: '11.5px',
            fontWeight: '500',
            letterSpacing: '0.01em',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            transition: 'all 0.25s ease-in-out',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.38)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.75)';
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.22)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.40)';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
          }}
        >
          <span>
            {i18n.language === "mr" ? "आवाज रूपांतरण:" : "Voice conversion by"}
          </span>

          {/* Bhashini Logo */}
          <img
            src="/assets/logos/bhashini-logo.svg"
            alt="Bhashini"
            style={{ height: '22px', width: 'auto', display: 'block' }}
          />

          <span style={{ fontSize: '11px', opacity: 0.85 }}>↗</span>
        </a>

        <p className="text-white/80">
          {i18n.language === "mr"
            ? `कॉपीराइट © ${displayYear}. सर्व हक्क राखीव.`
            : `Copyright © ${displayYear}. All rights reserved.`}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
